import { Box } from "@mui/material";
import { MaterialUiProviders } from "@src/mui/providers/MaterialUiProviders";
import React from "react";

export interface LegacyRouteWrapperProps {
  children: React.ReactNode;
}

export function LegacyRouteWrapper(props: LegacyRouteWrapperProps) {
  const { children } = props;

  return (
    <MaterialUiProviders>
      <Box padding={3}>{children}</Box>
    </MaterialUiProviders>
  );
}
